/* eslint-disable no-console */
import cookie from './cookie'

export default {
  /**
   * 获取是否是ios
   * @returns boolean
   */
  isIosByUA(): boolean {
    return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
  },
  /**
   * 当前是否是在Android中,从ua判断
   * @returns boolean
   */
  isAndroidByUA(): boolean {
    const ua = navigator.userAgent
    if (ua) {
      return Boolean(/android/i.exec(ua.toLowerCase()))
    }
    return false
  },
  /**
   * 当前是否是在Harmony中,从ua判断
   * Harmony 适配
   * @returns boolean
   */
  isHarmonyByUA(): boolean {
    const ua = navigator.userAgent
    if (ua) {
      return Boolean(/harmony/i.exec(ua.toLowerCase()))
    }
    return false
  },
  /**
   * 获取是否是QDios
   * @returns boolean
   */
  isQDIosByUA(): boolean {
    return /QDReaderAppstore/i.test(navigator.userAgent)
  },
  /**
   * 当前是否是在QdAndroid中,从ua判断
   * @returns boolean
   */
  isQDAndroidByUA(): boolean {
    const ua = navigator.userAgent
    if (ua) {
      return Boolean(/QDReaderAndroid/i.exec(ua.toLowerCase()))
    }
    return false
  },
  /**
   * 获取来源
   * @returns string
   */
  getFromStr(): string {
    const ua = navigator.userAgent
    if (/(micromessenger)/i.test(ua)) {
      return 'wechat'
    } else if (/(WeiBo)/i.test(ua)) {
      return 'weibo'
    } else if (/(mqqbrowser)/i.test(ua)) {
      return 'qq'
    }
    return 'other'
  },
  /**
   * 获取前端生成的标示 uuid
   * @returns string
   */
  getUUid(): string {
    let uuid = cookie.get('uuid')
    if (uuid) {
      return uuid
    }
    uuid = String(new Date().valueOf() + Math.random() * 1000)
    cookie.set({ name: 'uuid', value: uuid, day: 365 })
    return uuid
  },
  /**
   * 判断是iphoneX及以后的iphone手机（即iphone带全面屏的手机）
   * @returns boolean
   */
  isPhoneX(): boolean {
    return (
      this.isIosByUA() &&
      window.screen.height >= 812 &&
      window.devicePixelRatio >= 2
    )
  },

  // 检查是否支持webp
  checkWebp(callback: (isSupported: boolean) => void): void {
    const kTestImages = {
      lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
      lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
      alpha:
        'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
      animation:
        'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
    }
    const img = new Image()
    img.onload = () => {
      const result = img.width > 0 && img.height > 0
      callback(result)
    }
    img.onerror = () => {
      callback(false)
    }
    img.src = `data:image/webp;base64,${kTestImages.lossy}`
  },

  fallbackCopyTextToClipboard(text: string): void {
    const textArea = document.createElement('textarea')
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      const successful = document.execCommand('copy')
      const msg = successful ? 'successful' : 'unsuccessful'
      console.log(`Fallback: Copying text command was ${msg}`)
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err)
    }

    document.body.removeChild(textArea)
  },
  // copyTextToClipboard(text: string): void {
  //   if (!navigator.clipboard) {
  //     this.fallbackCopyTextToClipboard(text);
  //     return;
  //   }
  //   navigator.clipboard.writeText(text).then(
  //     () => {
  //       console.log("Async: Copying to clipboard was successful!");
  //     },
  //     (err) => {
  //       console.error("Async: Could not copy text: ", err);
  //     }
  //   );
  // },
  // href取特定的name对应的数据
  getQueryStringByName(original: string, name: string): string {
    const result = new RegExp(`[\?\&]${name}=([^\&]+)`, 'i').exec(original)
    if (result === null || result.length < 1) {
      return ''
    }
    return result[1]
  },
  /**
   * 获取是否是起点读书
   */
  isQD(): boolean {
    const ua = navigator.userAgent;
    if (ua) {
      return Boolean(/qdreader/i.exec(ua.toLowerCase()));
    }
    return false;
  },
  /**
   * 获取是否是QQ阅读
   */
  isQQReader(): boolean {
    const ua = navigator.userAgent;
    if (ua) {
      return Boolean(/qqreader/i.exec(ua.toLowerCase()));
    }
    return false;
  },
}
